<div class="container my-10 my-md-15">
  <div class="row" data-automation-id="contact-us-container">
    <div class="g-0 col-md-6 order-last order-md-first">
      <div
        class="d-flex justify-content-center w-100 h-100 bg-cloud-blue"
        data-automation-id="contact-us-flexbox"
      >
        <div class="d-flex flex-column justify-content-center h-100 p-7">
          <h3 class="text-primary" data-automation-id="contact-us-h3-title">
            Contact Us
          </h3>
          <p data-automation-id="we-are-here-to-help-text">
            Looking for information or answers? We're here to help!
          </p>
          <div class="my-6">
            <button
              type="button"
              class="digital-platform-button lg light primary"
              data-automation-id="contact-us-cta-button"
              [routerLink]="['/contact-us', ContactTypes.ENVIRONMENTAL]"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="g-0 col-md-6 order-first order-md-last">
      <picture>
        <source
          media="(min-width:768px)"
          srcset="
            /sites/default/files/styles/image_to_webp/public/V2_ReusableContent_EESFieldServiceEmployee.jpg.webp
          "
        />
        <img
          data-automation-id="contact-us-image"
          class="img-fluid"
          alt="Field employee smiling"
          src="/sites/default/files/styles/image_to_webp_mobile/public/V2_ReusableContent_EESFieldServiceEmployee.jpg.webp"
        />
      </picture>
    </div>
  </div>
</div>
